<template>
  <List
    title="parties"
    resource="parties"
    :basePath="basePath"
    :fields="fields"
    ref="list"
    on-row-click="edit"
    data-provider="$raaDataProvider"
    :initial-filter="entityDefaultFilter"
    :filter-classes="{container: 'w-2/3 items-end mb-6', quickFilters: 'w-1/2 mr-6', searchContainer: 'flex-1'}"
    :pageSize="20"
    infinity-scroll
  >
    <template v-slot:quickfilter="{applyFilter}">
      <div class="form-col">
        <label>{{entityFilterName}}</label>
        <Dropdown
          :options="entityFilterOptions"
          :value="entityFilterValue"
          @input="v => { applyFilter(mapEntityFilterToQuery(v)); }"
          show-all
          no-clear
        />
      </div>
    </template>
    <template v-slot:inline-actions="actionsScope">
      <button
        class="btn-action-warning"
        v-if="!actionsScope.record.deletedAt"
        @click.stop="deleteParty(actionsScope.record)"
      >
        <icon class="w-5 h-5 mr-1" name="trash"/>
      </button>
    </template>
  </List>
</template>

<script>
  import ConfirmationMixin from "@/mixins/ConfirmationMixin";
  import ModalNavigation from "@/mixins/ModalNavigation";
  import NotifyMixin from "@/mixins/NotifyMixin";
  import List from "@/components/auth/list/List";
  import Icon from "@/components/ui/Icon";
  import Dropdown from "@/components/ui/Dropdown";
  import EntityFilterMixin from "@/components/auth/EntityFilterMixin";

  export default {
    name: "PartiesList",
    components: {
      List,
      Icon,
      Dropdown,
    },
    mixins: [
      ModalNavigation,
      NotifyMixin,
      ConfirmationMixin,
      EntityFilterMixin,
    ],
    computed: {
      basePath: function () {
        return this.$route.path;
      },
    },
    data() {
      return {
        fields: [
          {
            name: 'contactId',
            title: 'contact id',
            sortField: 'contactId',
          },
          {
            name: 'type',
            title: 'type',
          },
          {
            name: 'communityId',
            title: 'community id',
            sortField: 'communityId',
          },
          {
            name: 'inline-actions',
            title: '',
          }
        ]
      }
    },
    methods: {
      deleteParty({ id }) {
        this.requestConfirmation({
          confirmationMessage: 'Are you sure you want to delete this party?',
          confirmBtnText: 'yes',
          cancelBtnText: 'no',
          confirmationType: 'warning'
        })
          .then(confirmed => confirmed
            ? this.$raaDataProvider.delete('parties', { id })
              .then(() => {
                this.$refs.list.doSearch();
                this.notifySuccess('party deleted');
              })
              .catch(error => this.notifyError(error.message))
            : null
          );
      }
    }
  }
</script>
